<template>
  <section>
    <div class="box">
      <div class="level item-information-column-direction">
        <div class="level-item has-text-centered" style="justify-content: space-between">
          <div style="display: flex; justify-content: space-around; width: 40%">
            <div class="margin-2">
              <p class="heading">LOTE</p>
              <p>
                <strong>{{ item.identificador }}</strong>
              </p>
            </div>
            <div class="margin-2">
              <p class="heading">Descrição</p>
              <p class="description-text" ref="description-text">
                <strong>{{ item.item.descricao }}</strong>
              </p>
            </div>
          </div>

          <div v-if="!isCrier" class="margin-2">
            <p class="heading">Lance Atual</p>
            <p class="description-text" ref="description-text">
              <strong>{{ lanceAtual }}</strong>
            </p>
          </div>

          <div class="margin-2">
            <p class="heading">Total Readequado</p>
            <p class="description-text" ref="description-text">
              <strong>
                {{ totalFormatado }}
                <span v-if="!isCrier" :class="{ 'has-text-danger': diferencaPositiva }">
                  ({{ diferencaFormatada }})
                </span>
              </strong>
            </p>
          </div>

          <div class="margin-2">
            <button class="button is-primary item-information-back-button" @click="handleVoltar">
              Voltar
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-loading :active="loading" is-full-page>
      <b-icon pack="fas" icon="sync-alt" size="is-large" custom-class="fa-spin" />
    </b-loading>

    <b-table
      v-if="!loading"
      :data="editableProposals"
      class="table is-fullwidth readjust-proposals-table"
      hoverable
      scrollable
      sticky-header
    >
      <b-table-column label="ID" v-slot="props" width="50">
        {{ props.row.identificador }}
      </b-table-column>

      <b-table-column label="Descrição" v-slot="props">
        {{ props.row.descricao }}
      </b-table-column>

      <b-table-column label="Quantidade" v-slot="props" centered width="110">
        {{ formatarNumero(editableProposals[props.index].quantidade || 0) }}
      </b-table-column>

      <b-table-column
        label="Referência"
        width="220"
        v-slot="props"
        centered
        v-if="divulgarReferencial || isCrier"
      >
        <span class="monetary-span">{{
          formatarValor(Number(getReference(editableProposals[props.index])) || 0)
        }}</span>
      </b-table-column>

      <b-table-column
        v-if="maiorDesconto && !isCrier"
        label="Percentual"
        width="180"
        v-slot="props"
      >
        <AppPorcentagem
          permitir-percentual-zero
          :item="props.row"
          :valores="valorBinding(props.row.id)"
          :valor-percentual="Number(editableProposals[props.index].percentual) || 0"
          :percentual-valido="percentualValido(editableProposals[props.index].percentual)"
          :width="'110'"
          :carregar-percentual="true"
          :desabilitar-campos="enviandoReadequacao || isCrier"
          @valor="payload => onPercentualChange(props.index, payload)"
        />
      </b-table-column>

      <b-table-column
        v-if="isCrier || maiorDesconto"
        label="Valor Unitário"
        width="180"
        v-slot="props"
        centered
      >
        <span
          v-if="isCrier"
          class="tag tag-extended"
          :class="colorBadge(editableProposals[props.index])"
        >
          {{ formatarValor(unitarioExibido(editableProposals[props.index])) }}
        </span>
        <span v-else>{{ formatarValor(unitarioExibido(editableProposals[props.index])) }}</span>
      </b-table-column>

      <b-table-column
        v-if="!maiorDesconto && !isCrier"
        label="Valor Unitário"
        width="200"
        v-slot="props"
      >
        <AppValor
          :item="props.row"
          :valores="valorBinding(props.row.id)"
          :valor-monetario="Number(editableProposals[props.index].valorUnitario) || 0"
          :valor-valido="valorValido(editableProposals[props.index].valorUnitario)"
          :exibir-input="true"
          :placeholder="'Valor unitário'"
          :width="'140'"
          :carregar-valor="true"
          :desabilitar-campos="enviandoReadequacao || isCrier"
          @valor="payload => onValorChange(props.index, payload)"
        />
      </b-table-column>

      <b-table-column label="Valor Total" width="180" v-slot="props" centered>
        <span
          v-if="isCrier"
          class="tag tag-extended"
          :class="colorBadge(editableProposals[props.index])"
        >
          {{ formatarValor(totalExibido(editableProposals[props.index])) }}
        </span>
        <span v-else>{{ formatarValor(totalExibido(editableProposals[props.index])) }}</span>
      </b-table-column>
    </b-table>

    <div v-if="!loading" class="has-text-right mt-4">
      <div
        class="has-text-right mt-4"
        style="display: flex; justify-content: end; align-items: center"
      >
        <div class="has-text-weight-bold" style="margin-right: 4vh">
          Total Readequado: {{ totalFormatado }}
          <span v-if="!isCrier" :class="{ 'has-text-danger': diferencaPositiva }">
            ({{ diferencaFormatada }})
          </span>
        </div>

        <b-tooltip
          position="is-left"
          size="is-medium"
          label="Readequação com valor superior ao lance"
          :active="diferencaPositiva"
        >
          <button
            v-if="!isCrier"
            class="button is-primary"
            :disabled="
              !editableProposals.length ||
              loading ||
              enviandoReadequacao ||
              temValorInvalido ||
              diferencaPositiva
            "
            @click="salvarReadequacoes"
          >
            {{ enviandoReadequacao ? 'Aguarde...' : textoBotao }}
          </button>
        </b-tooltip>

        <button
          v-if="isCrier"
          class="button is-primary ml-1"
          :disabled="disable.accept"
          @click="openModal(item.id, 'accept')"
        >
          Aceitar
        </button>
        <button
          v-if="isCrier"
          class="button is-danger ml-1"
          :disabled="disable.refuse"
          @click="openModal(item.id, 'refuse')"
        >
          {{ refuseButtonLabel }}
        </button>
      </div>
    </div>

    <b-modal
      has-modal-card
      ref="justificationModal"
      :onCancel="resetStateButtons"
      :active.sync="justification"
      @justificate="sendJustification"
    >
      <AppJustification
        v-if="justification"
        :displayFailButton="displayFailButton"
        :displaySuccessButton="displaySuccessButton"
        :failText="failText"
        :successText="successText"
      />
    </b-modal>
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { formatarNumero, formatarValor } from '@/utils/format';
import { calcularValorDePorcentagem } from '@/utils/calculations';
import AppValor from '@/components/AppValor';
import AppPorcentagem from '@/components/AppPorcentagem';
import AppJustification from '@/components/AppJustification';
import {
  discountPercentFromRanking,
  reconcileLotAmounts,
  resolveUnitInput,
  totalFromUnit,
  unitFromDiscount,
} from '@/utils/proposalAmounts';

const CURRENCY_SCALE = 10000;

export default {
  name: 'ReadjustProposals',
  components: { AppValor, AppPorcentagem, AppJustification },
  props: {
    item: { type: Object, required: true },
    isCrier: { type: Boolean, required: true },
    proposal: { type: Object, required: true },
    ofertaCompraId: { type: Number, required: true },
  },
  data() {
    return {
      loading: false,
      enviandoReadequacao: false,
      editableProposals: [],
      valoresCtrl: {},
      originalValuesMap: {},
      lanceAtualNumerico: 0,
      disable: { accept: false, refuse: false },
      action: '',
      itemId: null,
      justification: false,
      displaySuccessButton: false,
      displayFailButton: false,
      successText: '',
      failText: '',
    };
  },
  computed: {
    ...mapState('proposals', ['readjustedProposals']),
    ...mapGetters({
      ofertaCompra: 'obterOfertaCompra',
      getItem: 'obterItem',
    }),
    refuseButtonLabel() {
      return this.ofertaCompra.situacao.id === 19 ? 'Desclassificar' : 'Recusar';
    },
    tipoNegociacao() {
      return this.ofertaCompra.tipo_negociacao.id;
    },
    maiorDesconto() {
      return this.tipoNegociacao === 3;
    },
    lanceAtual() {
      return formatarValor(this.getItem(this.item.id).menor_lance.valor || 0);
    },

    temValorInvalido() {
      if (this.maiorDesconto) {
        return this.editableProposals.some(it => !this.percentualValido(it.percentual));
      }
      return this.editableProposals.some(it => (Number(it.valorUnitario) || 0) <= 0);
    },
    hasAlteracoes() {
      return this.editableProposals.some(it => {
        const original = this.originalValuesMap[it.id] || {};
        if (this.maiorDesconto) {
          return (
            this.toScaledCurrency(it.percentual) !== this.toScaledCurrency(original.percentual)
          );
        }
        return (
          this.toScaledCurrency(it.valorUnitario) !== this.toScaledCurrency(original.valorUnitario)
        );
      });
    },
    textoBotao() {
      return this.hasAlteracoes ? 'Enviar Readequação' : 'Confirmar Readequação';
    },
    totalBruto() {
      return this.totalEscalado / CURRENCY_SCALE;
    },
    totalEscalado() {
      return this.toScaledCurrency(this.totalReadequado);
    },
    totalReadequado() {
      const itens = this.editableProposals
        .filter(it => it.valorUnitario != null && Number(it.valorUnitario) > 0)
        .map(it => ({
          quantidade: it.quantidade,
          valorUnitario: it.valorUnitario,
        }));
      if (!itens.length) {
        return this.editableProposals.reduce((acc, it) => acc + (Number(it.valorTotal) || 0), 0);
      }
      return reconcileLotAmounts(itens).valorTotal;
    },
    totalFormatado() {
      return formatarValor(this.totalBruto);
    },
    valorComparacaoLance() {
      if (this.tipoNegociacao === 2) return this.totalReadequado;
      if (this.maiorDesconto) {
        return this.editableProposals.reduce((acc, it) => {
          const ranking =
            Number(it.total) > 0
              ? calcularValorDePorcentagem(it.total, it.percentual || 0)
              : Number(it.valor) || 0;
          return acc + ranking;
        }, 0);
      }
      return this.editableProposals.reduce((acc, it) => acc + (Number(it.valorUnitario) || 0), 0);
    },
    diferencaBruta() {
      return this.diferencaEscalada / CURRENCY_SCALE;
    },
    diferencaEscalada() {
      return (
        this.toScaledCurrency(this.valorComparacaoLance) -
        this.toScaledCurrency(this.lanceAtualNumerico)
      );
    },
    diferencaFormatada() {
      const diff = this.diferencaBruta;
      const abs = formatarValor(Math.abs(diff));
      if (diff === 0) return abs;
      return diff < 0 ? `-${abs}` : `+${abs}`;
    },
    diferencaPositiva() {
      return this.diferencaEscalada > 0;
    },
    divulgarReferencial() {
      return this.ofertaCompra.divulgar_referencial;
    },
  },
  watch: {
    readjustedProposals: {
      immediate: true,
      deep: true,
      handler(lista) {
        if (!Array.isArray(lista)) {
          this.editableProposals = [];
          this.valoresCtrl = {};
          this.originalValuesMap = {};
          this.lanceAtualNumerico = 0;
          return;
        }

        this.editableProposals = lista.map(it => this.mapearLinhaReadequacao(it));

        const originals = {};
        this.editableProposals.forEach(it => {
          originals[it.id] = {
            valorUnitario: Number(it.valorUnitario) || 0,
            percentual: Number(it.percentual) || 0,
          };
        });
        this.originalValuesMap = originals;

        const ctrl = {};
        this.editableProposals.forEach(it => {
          const prev = this.valoresCtrl[it.id];
          ctrl[it.id] = {
            itemId: it.id,
            ofertaCompraPropostaLoteItemId: it.ofertaCompraPropostaLoteItemId,
            valor: it.valorUnitario,
            percentual: it.percentual,
            valorMascara:
              prev && prev.valorMascara
                ? prev.valorMascara
                : formatarValor(Number(it.valorUnitario) || 0),
          };
        });
        this.valoresCtrl = ctrl;

        this.$nextTick(() => this.recalcularLanceAtual());
      },
    },
    isCrier() {
      this.$nextTick(() => this.recalcularLanceAtual());
    },
    'item.menor_lance.valor': function changeMenorLance() {
      if (this.isCrier) this.recalcularLanceAtual();
    },
  },
  sockets: {
    'ofertacompra:proposta-readequada': function listReadjustProposal() {
      if (this.isCrier) {
        this.listReadjustProposal({
          auctionId: this.ofertaCompraId,
          auctionItemId: this.item.id,
          proposalId: this.proposal.id,
        });
      }
    },
    'ofertacompra:itens': function recalcularLance() {
      this.recalcularLanceAtual();
    },
  },
  methods: {
    ...mapActions('proposals', [
      'readjustProposal',
      'listReadjustProposal',
      'manualReadjustProposal',
    ]),
    ...mapActions(['aceitarLanceNegociacao', 'recusarLanceNegociacao']),
    formatarValor,
    formatarNumero,
    handleVoltar() {
      this.$emit('voltar');
    },
    mapearLinhaReadequacao(it) {
      const quantidade = it.quantidade != null ? Number(it.quantidade) : 0;
      const referencia = it.referencia !== null ? Number(it.referencia) : 0;
      const total = it.total !== null ? Number(it.total) : 0;
      const rankingValor = it.valor !== null ? Number(it.valor) : 0;
      let valorUnitario = resolveUnitInput(it, this.tipoNegociacao);
      let percentual = it.percentual != null ? Number(it.percentual) : null;
      if (percentual == null) {
        percentual = this.maiorDesconto ? discountPercentFromRanking(total, rankingValor) : 0;
      }
      if (valorUnitario == null && this.maiorDesconto && referencia > 0) {
        valorUnitario = unitFromDiscount(referencia, percentual);
      }
      let valorTotal = it.valorTotal != null ? Number(it.valorTotal) : null;
      if (valorTotal == null && valorUnitario != null) {
        valorTotal = totalFromUnit(valorUnitario, quantidade);
      }

      return {
        id: it.id,
        identificador: it.identificador,
        ofertaCompraPropostaLoteItemId: it.ofertaCompraPropostaLoteItemId,
        descricao: it.descricao,
        quantidade,
        valor: rankingValor,
        valorUnitario,
        valorTotal,
        percentual,
        referencia,
        total,
        lanceAtual: it.lanceAtual || 0,
      };
    },
    getReference(item) {
      if (this.tipoNegociacao === 1) return item.referencia;

      if (this.tipoNegociacao === 2) return item.total;

      return item.referencia;
    },
    colorBadge(item) {
      const comparado =
        this.tipoNegociacao === 2 ? this.totalExibido(item) : this.unitarioExibido(item);
      const referencia = this.getReference(item);
      return Number(comparado) > Number(referencia) ? 'is-danger' : 'is-success';
    },
    unitarioExibido(item) {
      if (item.valorUnitario != null) return Number(item.valorUnitario);
      if (this.tipoNegociacao === 1) return Number(item.valor) || 0;
      return 0;
    },
    totalExibido(item) {
      if (item.valorTotal != null) return Number(item.valorTotal);
      return Number(item.valor) || 0;
    },
    valorValido(value) {
      return Number.isFinite(Number(value)) && Number(value) > 0;
    },
    percentualValido(value) {
      const percentual = Number(value);
      return Number.isFinite(percentual) && percentual >= 0 && percentual < 100;
    },
    valorBinding(id) {
      if (!this.valoresCtrl[id]) {
        this.$set(this.valoresCtrl, id, {
          itemId: id,
          valor: 0,
          percentual: 0,
          valorMascara: '',
        });
      }
      return this.valoresCtrl[id];
    },
    atualizarTotaisLinha(index, patch) {
      const atual = this.editableProposals[index];
      const copy = { ...atual, ...patch };
      if (copy.valorUnitario != null) {
        copy.valorTotal = totalFromUnit(copy.valorUnitario, copy.quantidade);
      }
      this.$set(this.editableProposals, index, copy);
      return copy;
    },
    onValorChange(index, payload) {
      const raw = payload && payload.valor;
      const normalizado = typeof raw === 'string' ? raw.replace(/\./g, '').replace(',', '.') : raw;
      const valorDigitado = Number(normalizado);
      const valorFinal = Number.isFinite(valorDigitado) ? valorDigitado : 0;

      const copy = this.atualizarTotaisLinha(index, { valorUnitario: valorFinal });

      const { id, ofertaCompraPropostaLoteItemId } = copy;
      this.$set(this.valoresCtrl, id, {
        ...(this.valoresCtrl[id] || { itemId: id, ofertaCompraPropostaLoteItemId }),
        ...payload,
        valor: valorFinal,
        valorMascara:
          (payload && payload.valorMascara) ||
          (this.valoresCtrl[id] && this.valoresCtrl[id].valorMascara) ||
          formatarValor(valorFinal),
      });
    },
    onPercentualChange(index, payload) {
      const percentual = Number(payload && payload.percentual);
      const atual = this.editableProposals[index];
      const valorUnitario =
        atual.referencia > 0 && Number.isFinite(percentual)
          ? unitFromDiscount(atual.referencia, percentual)
          : null;

      const copy = this.atualizarTotaisLinha(index, {
        percentual: Number.isFinite(percentual) ? percentual : 0,
        valorUnitario,
      });

      const { id, ofertaCompraPropostaLoteItemId } = copy;
      this.$set(this.valoresCtrl, id, {
        ...(this.valoresCtrl[id] || { itemId: id, ofertaCompraPropostaLoteItemId }),
        ...payload,
        percentual: copy.percentual,
      });
    },

    toScaledCurrency(value) {
      const numericValue = Number(value) || 0;
      return Math.round(numericValue * CURRENCY_SCALE);
    },

    recalcularLanceAtual() {
      this.lanceAtualNumerico = Number(this.getItem(this.item.id).menor_lance.valor) || 0;
    },

    async carregarDados() {
      this.loading = true;
      try {
        if (this.isCrier) {
          await this.listReadjustProposal({
            auctionId: this.ofertaCompraId,
            auctionItemId: this.item.id,
            proposalId: this.proposal.id,
          });
        } else {
          await this.readjustProposal({
            auctionId: this.ofertaCompraId,
            auctionItemId: this.item.id,
          });
        }
        this.$nextTick(() => this.recalcularLanceAtual());
      } finally {
        this.loading = false;
      }
    },

    async salvarReadequacoes() {
      if (this.temValorInvalido) return;

      this.enviandoReadequacao = true;

      const payload = this.editableProposals.map(item => {
        const linha = {
          propostaLoteItemId: item.ofertaCompraPropostaLoteItemId,
        };
        if (this.maiorDesconto) {
          linha.percentual = item.percentual;
        } else {
          linha.valorUnitario = item.valorUnitario;
        }
        return linha;
      });

      try {
        const ok = await this.manualReadjustProposal({
          auctionId: this.ofertaCompraId,
          auctionItemId: this.item.id,
          payload,
          isCrier: this.isCrier,
          proposalId: this.proposal?.id || null,
        });

        if (ok) {
          this.$nextTick(() => this.recalcularLanceAtual());
          const originals = {};
          this.editableProposals.forEach(it => {
            originals[it.id] = {
              valorUnitario: Number(it.valorUnitario) || 0,
              percentual: Number(it.percentual) || 0,
            };
          });
          this.originalValuesMap = originals;

          this.$alerta('Readequação enviada com sucesso', 'is-success');
        } else {
          this.$alerta('Erro ao enviar readequação', 'is-danger');
        }
      } catch (e) {
        this.$alerta('Erro ao enviar readequação', 'is-danger');
      } finally {
        this.enviandoReadequacao = false;
      }
    },

    openModal(itemId, action) {
      this.itemId = itemId;
      this.action = action;

      if (action === 'accept') {
        this.disable.accept = true;
        this.disable.refuse = true;
        this.displaySuccessButton = true;
        this.displayFailButton = false;
        this.successText = 'Aceitar';
      } else if (action === 'refuse') {
        this.disable.refuse = true;
        this.disable.accept = true;
        this.displayFailButton = true;
        this.displaySuccessButton = false;
        this.failText = 'Recusar';
      }

      this.justification = true;
    },

    resetStateButtons() {
      this.disable.accept = false;
      this.disable.refuse = false;
    },

    async sendJustification({ justification }) {
      try {
        if (this.action === 'accept') {
          await this.acceptOffer({
            itemId: this.itemId,
            justificativa: justification || 'Preço aceito.',
          });
        } else if (this.action === 'refuse') {
          await this.refuseOffer({
            itemId: this.itemId,
            justificativa: justification,
          });
        }
      } finally {
        this.itemId = null;
        this.action = '';
      }
    },

    async acceptOffer({ itemId, justificativa }) {
      const ok = await this.aceitarLanceNegociacao({ itemId, justificativa });
      if (ok) {
        // re-fetch (visão pregoeiro)
        await this.listReadjustProposal({
          auctionId: this.ofertaCompraId,
          auctionItemId: this.item.id,
          proposalId: this.proposal.id,
        });
        this.$nextTick(() => this.recalcularLanceAtual());
        this.$alerta('Proposta aceita', 'is-success');
      } else {
        this.$alerta('Erro ao aceitar proposta', 'is-danger');
      }
      this.disable.accept = false;
      this.disable.refuse = false;
      this.sendCloseModal();
    },

    async refuseOffer({ itemId, justificativa }) {
      const ok = await this.recusarLanceNegociacao({ itemId, justificativa });
      if (ok) {
        // re-fetch (visão pregoeiro)
        await this.listReadjustProposal({
          auctionId: this.ofertaCompraId,
          auctionItemId: this.item.id,
          proposalId: this.proposal.id,
        });
        this.$nextTick(() => this.recalcularLanceAtual());
        this.$alerta('Proposta recusada', 'is-danger');
      } else {
        this.$alerta('Erro ao recusar proposta', 'is-danger');
      }
      this.disable.refuse = false;
      this.disable.accept = false;
      this.sendCloseModal();
    },

    sendCloseModal() {
      this.justification = false;
      this.$refs.justificationModal.close();
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style lang="scss" scoped>
.options-button {
  font-size: 0.9rem;
}

.align-right {
  text-align: right;

  .field {
    justify-content: flex-end;
  }
}

.readjust-proposals-table ::v-deep .table-wrapper.has-sticky-header {
  height: auto;
  max-height: 60vh;
  overflow-y: auto;
}
</style>
